"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Accordion = _interopRequireDefault(require("@commerce-ui/core2/Accordion"));
var _ShowHide = _interopRequireDefault(require("@commerce-ui/core2/ShowHide"));
var _Button = _interopRequireDefault(require("@commerce-ui/core2/Button"));
var _parseProductDescription = _interopRequireDefault(require("@deosite/helpers/parseProductDescription"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  qtyWithButton: false,
  accordionTextFont: "body",
  accordionLabelFont: "label",
  detailMarginTop: "s8",
  accordionBarPadding: {
    top: 17,
    bottom: 13
  }
};
var ProductDataAccordion = function ProductDataAccordion(props) {
  var productInfo = props.productInfo,
    translations = props.translations,
    br = props.br,
    _props$detailMarginTo = props.detailMarginTop,
    detailMarginTop = _props$detailMarginTo === void 0 ? defaultProps.detailMarginTop : _props$detailMarginTo,
    _props$accordionLabel = props.accordionLabelFont,
    accordionLabelFont = _props$accordionLabel === void 0 ? defaultProps.accordionLabelFont : _props$accordionLabel,
    _props$accordionTextF = props.accordionTextFont,
    accordionTextFont = _props$accordionTextF === void 0 ? defaultProps.accordionTextFont : _props$accordionTextF,
    _props$qtyWithButton = props.qtyWithButton,
    qtyWithButton = _props$qtyWithButton === void 0 ? defaultProps.qtyWithButton : _props$qtyWithButton,
    _props$accordionBarPa = props.accordionBarPadding,
    accordionBarPadding = _props$accordionBarPa === void 0 ? defaultProps.accordionBarPadding : _props$accordionBarPa;
  productInfo.safetyTitle = translations.safetyDescription;
  return __jsx(_Accordion["default"], {
    sx: {
      mt: "s10"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: qtyWithButton ? 0 : "1px",
      bg: "neutral"
    }
  }), productInfo && Object.entries(productInfo).map(function (_ref, index) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      title = _ref2[0],
      value = _ref2[1];
    return value === null || value === "" ? null : [__jsx(_Accordion["default"].Section, {
      isOpenAtInit: index === 0
    }, __jsx(_Button["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        pt: accordionBarPadding.top,
        pb: accordionBarPadding.bottom,
        width: "100%",
        color: "main"
      }
    }, function (_ref3) {
      var selected = _ref3.selected;
      return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
        sx: {
          font: accordionLabelFont
        }
      }, translations[title]), __jsx(_Box["default"], {
        sx: {
          transform: selected ? "rotate(180deg)" : "none",
          transition: "all .3s ease-out"
        }
      }, __jsx(ChevronDownIcon, null)));
    }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
      sx: _objectSpread({
        p: "16px 0px",
        pt: 0,
        font: accordionTextFont,
        color: "main"
      }, br)
    }, Array.isArray(value) > 0 ? value.map(function (value, index) {
      if (!(value !== null && value !== void 0 && value.name)) {
        return;
      }
      return __jsx(_Box["default"], {
        sx: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginTop: detailMarginTop
        },
        key: index
      }, __jsx(_Box["default"], {
        sx: {
          width: "50%"
        }
      }, translations[value.label]), __jsx(_Box["default"], {
        sx: {
          width: "50%"
        }
      }, value.label === "capacity" ? parseFloat(value.name) / 1000 : isNaN(value.name) ? value.name.toString().split(",").join(", ") : parseFloat(value.name).toString()));
    }) : __jsx(_Box["default"], {
      sx: {
        a: {
          color: "main"
        }
      },
      dangerouslySetInnerHTML: {
        __html: (0, _parseProductDescription["default"])(value)
      }
    })))), __jsx(_Box["default"], {
      sx: {
        height: qtyWithButton ? 0 : "1px",
        bg: "neutral"
      }
    })];
  }));
};
var _default = ProductDataAccordion;
exports["default"] = _default;